import { Action, ActionReducer } from '@ngrx/store';
import { FilesControllerUploadDataImportFile200Response } from '../../../_generated';
import { FileImportActionTypes } from '../../actionstypes/file-import/file-import.actiontype';

export interface FileImportState {
  uploadReport: FilesControllerUploadDataImportFile200Response | null;
}

const initialState: FileImportState = {
  uploadReport: null,
};

const fileImportReducer = (state = initialState, action: any): FileImportState => {
  switch (action.type) {
    case FileImportActionTypes.Set:
      return {
        ...state,
        uploadReport: action.payload,
      };

    case FileImportActionTypes.Clear:
      return {
        ...state,
        uploadReport: null,
      };

    default:
      return state;
  }
};

export default fileImportReducer as ActionReducer<FileImportState, Action<string>>;
